import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/shared/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class TechnicalEventsService {
  constructor(private http: HttpClient, private authService: AuthService) {}

  private url(path: string): string {
    const base =
      this.authService.getOriginCurrency() !== 'BRL'
        ? environment.intlUrl
        : environment.apiUrl;

    return `${base}${path}`;
  }

  getLogIntegration(params: {
    idTransaction?: string;
    type?: string;
    startDate: string;
    endDate: string;
    page: number;
    pageSize: number;
  }): Observable<any> {
    let qp = new HttpParams()
      .set('startDate', params.startDate)
      .set('endDate', params.endDate)
      .set('page', params.page)
      .set('pageSize', params.pageSize);

    if (params.idTransaction) qp = qp.set('idTransaction', params.idTransaction);
    if (params.type) qp = qp.set('type', params.type);

    return this.http.get<any>(this.url('/logIntegration'), { params: qp });
  }
}